import { render, staticRenderFns } from "./ProductConsulting.vue?vue&type=template&id=fbe713e4&scoped=true&"
import script from "./ProductConsulting.vue?vue&type=script&lang=js&"
export * from "./ProductConsulting.vue?vue&type=script&lang=js&"
import style0 from "./ProductConsulting.vue?vue&type=style&index=0&id=fbe713e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe713e4",
  null
  
)

export default component.exports